exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.flag-icon {\n    margin-right: 12px;\n}\n.activator input {\n    cursor: pointer;\n}\n.langs-container {\n    padding: 40px;\n    background: white;\n}\n.lang-input {\n    width: 80%;\n}\n", ""]);

// exports
